import React, { useEffect, useState } from 'react';
import { FormLabel, TextField, Skeleton } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useObjectContext } from '@/hooks/useObjectContext';
import { minimalInputTheme } from '@/app/theme';
import { useUpdateDealRowMutation } from '@/features/deals/dealsApi';

export const DealCardAdviserFee = () => {
	const { dealRow } = useObjectContext();

	const [adviserFeeValue, setAdviserFeeValue] = useState(dealRow?.adviserFee ?? 0);

	useEffect(() => {
		setAdviserFeeValue(dealRow?.adviserFee ?? 0);
	}, [dealRow?.adviserFee]);

	const [updateDealRow, { isLoading }] = useUpdateDealRowMutation();

	const updateAdviserFee = async () => {
		await updateDealRow({
			dealId: dealRow?.dealId,
			properties: {
				adviserFee: adviserFeeValue,
			},
		}).unwrap();
	};

	return <>
		<FormLabel>Current premium</FormLabel>
		{isLoading ? <Skeleton animation='wave' width='55%' height='2em' /> : <NumericFormat
			fullWidth
			disabled={isLoading}
			customInput={TextField}
			thousandSeparator
			decimalScale={0}
			fixedDecimalScale
			allowNegative={false}
			prefix="$"
			variant="standard"
			sx={minimalInputTheme}
			className="minimal-input"
			value={adviserFeeValue}
			onValueChange={({floatValue}) => setAdviserFeeValue(floatValue)}
			onBlur={updateAdviserFee}
		/>}
	</>;
};